import React from 'react'
import DisplayHeaderOnTour from './display'

const HeaderOnTour = ({ ...props }) => <DisplayHeaderOnTour {...props} />

export default HeaderOnTour
